@let headerSpacingClass = useLargeText ? 'pt-2' : 'py-1 mb-0';
@let cellPaddingClass = useLargeText ? 'py-2' : 'si-enrichment-cell-padding';

<div class="h-full w-full si-card si-enrichment-card">
    <div class="border-b px-4 py-2">
        <h3
          [ngClass]="headerSpacingClass"
        >
          Enrichment
        </h3>
    </div>
    <div class="h-full" *ngIf="isLoading; else enrichmentCard">
        <div class="flex justify-center items-center h-full w-full">
            <mat-spinner></mat-spinner>
        </div>
    </div>

    <ng-template #enrichmentCard>
        <ng-container *ngIf="(!enrichmentData || enrichmentData?.length === 0); else enrichmentSummary">

        <div class="flex flex- py-12 px-12 flex-wrap justify-center h-full items-center">
            <p class="text-center pb-2 text-secondary empty-state-text font-light">
                No enrichment records or jobs have run on your account.
            </p>
          </div>
        </ng-container>

        <ng-template #enrichmentSummary>
          <div class="flex flex-col overflow-auto flex-1 min-h-0 w-full px-4">
            <p *ngIf="useLargeText" class="mb-1 text-si-h4 font-normal text-center">
              Enrichment Activity
            </p>
            <div class="grid-data flex-1 min-h-0 flex items-center w-full" [class.mb-3]="useLargeText">
                <table class="align-middle text-center w-full border-separate border-spacing-0">
                    <colgroup>
                        <col style="width: 30%;">
                        <col style="width: 23.3%;">
                        <col style="width: 23.3%;">
                        <col style="width: 23.3%;">
                    </colgroup>
                    <tbody>
                        <tr>
                            <td [ngClass]="cellPaddingClass"></td>
                            <td class="text-right text-si-h4  whitespace-nowrap" [ngClass]="cellPaddingClass">Past 30 Days</td>
                            <td class="text-right text-si-h4  whitespace-nowrap" [ngClass]="cellPaddingClass">Past 90 Days</td>
                            <td class="text-right text-si-h4  whitespace-nowrap" [ngClass]="cellPaddingClass">All Time</td>
                        </tr>
                        <tr>
                            <td class="text-left text-si-h4  whitespace-nowrap" [ngClass]="cellPaddingClass">Records Analyzed</td>
                            <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">{{
                                enrichmentData.past30DaysRecordAnalyzed | numberAbbreviator }}</td>
                            <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">{{
                                enrichmentData.past90DaysRecordAnalyzed | numberAbbreviator }}</td>
                            <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">{{
                                enrichmentData.totalRecordAnalyzed | numberAbbreviator }}</td>
                        </tr>
                        <tr>
                            <td class="text-left text-si-h4  whitespace-nowrap" [ngClass]="cellPaddingClass">Records Enriched</td>
                            <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">{{
                                enrichmentData.past30DaysRecordUpdated | numberAbbreviator }}</td>
                            <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">{{
                                enrichmentData.past90DaysRecordUpdated | numberAbbreviator }}</td>
                            <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">{{
                                enrichmentData.totalRecordUpdated | numberAbbreviator }}</td>
                        </tr>
                        <tr>
                            <td class="text-left text-si-h4  whitespace-nowrap" [ngClass]="cellPaddingClass">Bulk Jobs Run</td>
                            <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">{{
                                enrichmentData.past30DaysTotalJobRun | numberAbbreviator }}</td>
                            <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">{{
                                enrichmentData.past90DaysTotalJobRun | numberAbbreviator }}</td>
                            <td class="font-medium text-right text-si-h4" [ngClass]="cellPaddingClass">{{
                                enrichmentData.totalJobRun | numberAbbreviator }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </ng-template>
      </ng-template>
</div>
